import type { ApolloClient as ApolloClientBase } from '@apollo/client';
import { ApolloLink } from '@apollo/client';
import { ApolloClient, InMemoryCache } from '@apollo/client-integration-nextjs';
import { isClient } from 'corgi/common/utils/isClient';

import { type GQLClientProps } from './client-props';
import { getHttpLink, getLoggerLink, persistedQueryLink, retryLink } from './links';

export type ApolloGQLClient = ApolloClientBase<unknown>;

export const makeApolloClient = (clientProps: GQLClientProps) => {
  const httpLink = getHttpLink(clientProps);
  const loggerLink = getLoggerLink(clientProps.requestId);

  const links = [
    ...(isClient() ? [] : [loggerLink, retryLink]),
    persistedQueryLink.concat(httpLink),
  ];

  return new ApolloClient({
    cache: new InMemoryCache(),
    link: ApolloLink.from(links),
    devtools: {
      enabled: process.env.STAGE !== 'production',
    },
    defaultOptions: {
      watchQuery: {
        fetchPolicy: 'no-cache',
        errorPolicy: 'all',
      },
      query: {
        fetchPolicy: 'no-cache',
        errorPolicy: 'all',
      },
      mutate: {
        fetchPolicy: 'no-cache',
        errorPolicy: 'all',
      },
    },
  });
};
